module.exports = __webpack_public_path__ + "8fbe283174b4b465a12a781d28cea9fb.svg";